/* eslint-disable simple-import-sort/imports */
import minimal from "./minimal";
//#!if ENV !== "production"
// import jones2 from "./jones2";
//#!endif

export default [
  {
    id: "minimal",
    label: "Minimal",
    icon: "basic",
    template: minimal,
    category: "general",
    creator: "Timeline.App",
    description: "A bare-bones template containing events, people and locations"
  },
  //#!if ENV !== "production"
// {
// id: "jones2",
// label: "Jones 2",
// icon: "number",
// template: jones2
// }
  //#!endif
];
